import APP from 'app';
import Constants from 'constants';
const { Utils } = APP,
    { getUserInfoFromJwt } = Utils;

const setGuestTokenDekorator = (response = {}) => {
    const { status = {} } = response;
    const { success = false } = status;
    const type = success ? Constants.actions.USER.USER_LOGIN_SUCCESS : Constants.actions.USER.USER_LOGIN_FAILURE;
    if (!success) return { type, payload: response };
    const { headers = {} } = response;
    const { authorization: accessToken = '' } = headers;
    const user = getUserInfoFromJwt(accessToken);
    return { type, payload: { status, user, accessToken } };
}

export default setGuestTokenDekorator;
